import { useDynamicEntityCMSDataContext, useDynamicEntityStoreContext } from '../contexts';

import { COMPONENT_IDENTIFIER_KEYWORD, BARRED_DUPLICATE_COMPONENTS } from '../lib';

import PropField from './_component_settings/PropField';

export default function ComponentSettingsPane() {
  const { componentDefinitions, isModule } = useDynamicEntityCMSDataContext();

  const content = useDynamicEntityStoreContext((state) => state.data.content);
  const componentBeingEditedIndex = useDynamicEntityStoreContext((state) => state.componentBeingEditedIndex);

  const update = useDynamicEntityStoreContext((state) => state.update);

  const images = useDynamicEntityStoreContext((state) => state.images);
  const addContent = useDynamicEntityStoreContext((state) => state.addContent);
  const removeContent = useDynamicEntityStoreContext((state) => state.removeContent);

  const component = content[componentBeingEditedIndex] || null;

  const definition = componentDefinitions.find((c) => {
    const componentIdentifier = c[COMPONENT_IDENTIFIER_KEYWORD];
    const currentComponentIdentifier = component?.[COMPONENT_IDENTIFIER_KEYWORD];

    return componentIdentifier !== undefined && currentComponentIdentifier !== undefined && componentIdentifier === currentComponentIdentifier;
  });

  const isBarredComponent = BARRED_DUPLICATE_COMPONENTS.includes(component?.[COMPONENT_IDENTIFIER_KEYWORD]);

  const handleRemoveComponent = () => {
    removeContent(component.id);
    update({ activePane: isModule ? 0 : 1 });
  };

  const handleDuplicateComponent = () => {
    addContent({ ...component, id: crypto.randomUUID() });
    update({ activePane: isModule ? 0 : 1 });
  };

  if (!definition) {
    return (
      <div className="d-flex flex-column gap-3">
        <h3>Error</h3>
        <p className="text-muted">This component is not found in the current code configuration of this site.</p>
        <p className="text-muted">Please ensure the code responsible for this component is properly configured.</p>
        <p className="text-muted">Remove this component and re-add back in again using the previous page.</p>
        <button type="button" className="btn btn-danger" onClick={handleRemoveComponent}>
          Remove
        </button>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column pb-4 h-100 overflow-auto">
      <div className="d-flex flex-column gap-1 mb-3">
        <div className="d-flex flex-column">
          <h3 className="mb-1 w-100 d-inline-block text-truncate">Editing {definition[COMPONENT_IDENTIFIER_KEYWORD] || 'Component'}</h3>
          <p className="text-muted mb-0">This component is #{componentBeingEditedIndex + 1} on the components list.</p>
        </div>
        <div>
          <div className="btn-group">
            <button type="button" className="btn btn-danger" onClick={handleRemoveComponent}>
              Remove
            </button>

            <button type="button" className="btn btn-danger dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
              <span className="visually-hidden">Toggle Dropdown</span>
            </button>
            <ul className="dropdown-menu">
              <li>
                <button type="button" className="dropdown-item" onClick={handleDuplicateComponent} disabled={isBarredComponent}>
                  Duplicate
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="d-flex flex-wrap px-2">
        {definition?.propSchema?.map((prop, index) => {
          if (!prop) {
            return (
              <div className="dp-prop-field my-2 text-danger" key={index}>
                An invalid prop is detected here. Please remove or fix it.
              </div>
            );
          }

          if (prop.grouped_under) {
            return null; // Skip props that are grouped under another prop
          }

          return <PropField key={index} {...{ component, ...prop }} />;
        })}
      </div>
    </div>
  );
}
